import { render, staticRenderFns } from "./lottery.vue?vue&type=template&id=6ca9fb84&scoped=true&"
import script from "./lottery.vue?vue&type=script&lang=js&"
export * from "./lottery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca9fb84",
  null
  
)

export default component.exports